<script setup lang="ts">
import { computed } from 'vue';
import { alignmentClasses, type UiAlignment } from '../ui-layout/classes';

const props = withDefaults(defineProps<{
    align?: UiAlignment;
}>(), {
    align: 'center'
});

const classes = computed(() => [
    'inline-flex [&>.ideo-action:not(:first-child)]:-ms-px [&>.ideo-action:not(:first-child)]:rounded-s-none [&>.ideo-action:not(:last-child)]:rounded-e-none',
    alignmentClasses[props.align]
]);
</script>

<template>
    <div :class="classes" role="group">
        <slot name="default" />
    </div>
</template>
